export enum InstanceSettingsTabs {
  General,
  SKUs,
  StandardPrograms,
  Resources,
  Sage,
  Stripe,
}
